var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn num-btn",attrs:{"id":"NUMBER_3","name":"3","data-vcode":"NUMBER_3","aria-label":"3 DEF"}},[_c('div',{staticClass:"digit"},[_vm._v("3")]),_c('div',{staticClass:"letters"},[_vm._v("DEF")])])
}]

export { render, staticRenderFns }